import "./InvoiceDetailsNew.css";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { DiscountDetails, viewManageOrderRowsData } from "../../viewOrder/ViewOrderType";
import {
  getSingleOrder,
  createInvoice,
  getSalesData,
} from "../../../services/manageOrderService";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getMetaData1,
  metaData2,
  getEditOrderConfig,
  getViewOrderConfig,
  setAndGetViewOrderEditTableHeader,
} from "../../viewOrder/ViewOrderConfig";
import "../../manageBasket/ManageBasket.css";
import { Loader } from "../../../components/loader/Loader";
import RenderSvg from "../../../components/renderSvg/RenderSvg";
import BorderHeading from "../../../components/heading/BorderHeading";
import CustomAccordian from "../../../components/dms_common/CustomAccordian";
import {
  checkAllRowsHaveValidStock,
  createAndDownloadInvoicePdf,
  createSkuWiseStockMap,
  getBatchCodes,
  getOrderTotalRowData,
  initialDiscountState,
  ordersWithStockExceedingWarning,
  getGenericModalProps,
  initialGenericModalProps,
  GenericModal,
  buttonLoading,
  stages,
  checkIfNHoursPassed,
} from "../../viewOrder/ViewOrderUtils";
import CustomTablewithTotalInfo from "../../../components/dms_common/CustomTablewithTotalInfo";
import NewDiscountModal from "../modals/NewDiscountModal";
import { setDiscountModalState } from "../../../stateManagement/actions/claims";
import { setRealTimeStockDataInDb } from "../../stocks/RealTimeStock/RealTimeStockUtils";
import { ReactComponent as DisclaimerIcon } from "../../../assets/image/svg/disclaimer.svg";
import Search from "../../../components/dms_common/Search";
import { getDataFromLocalDb} from "../../../services/dbService";
import { getConfigData } from "../../../services/configurationService";
import "../../viewOrder/ViewOrder.css";
import { handleScroll, handleScrollCustomDataGrid, truncateToTwoDecimals } from "../../../components/dms_common/DmsUtils";

const InvoiceDetailsTov = () => {
  const { orderId } = useParams();
  const [rows, setRows] = useState<viewManageOrderRowsData[]>([]);
  const [loader, setLoader] = useState(true);
  const [totalFooterValue, setTotalFooterValue] = useState<any[]>([]);
  const [orderData, setOrderData] = useState<any>({});
  const [invoiceExpired, setInvoiceExpired] = useState<boolean>(false);
  const [orderTrackingConfig, setOrderTrackingConfig] = useState<any[]>([]);
  const [isScrolling, setIsScrolling] = useState(false);
  const [searchedValue, setSearchedValue] = useState<string>("");
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [selectedSkuCode, setSelectedSkuCode] = useState<any>({});
  const [orderStatusChangeLoading, setOrderStatusChangeLoading] = useState<string>("");
  const [genericModalProps, setGenericModalProps] = useState<GenericModal>(initialGenericModalProps);
  const [canPushToEInvoice, setCanPushToEInvoice] = useState<boolean>(false);
  const [TableHeaders, SetViewOrderEditTableHeader] = useState<Record<string, string>>({});
  const [editLoading, setEditLoading] = useState<boolean>(false);
  const [rejectionReasons, setRejectionReasons] = useState<string[]>([]);
  const [invoiceReportName, setInvoiceReportName] = useState<string>("");
  const [invoiceTaskName, setInvoiceTaskName] = useState<string>("");
  const hideAddMoreInEditOrder = useRef<boolean>(false);
  const disableStockCheck = useRef<boolean>(false);
  const hideItemLevelTaxInfo = useRef<boolean>(false);
  const showGoToInvoiceRedirectionButton = useRef<boolean>(false);
  const disableEditInvoiceFlow = useRef<boolean>(false);
  const hideOrderProgressCard = useRef<boolean>(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");

  const insideManageInvoice = location?.pathname?.includes("viewInvoice");

  // those rows are valid which are not a free product
  const validRows = [...rows]?.filter((row: viewManageOrderRowsData) => !row?.freeItem);

  const onCustomAccordionToggle = (isExpanded: boolean) => {
    setIsScrolling(!isExpanded);
  };

  const handlePromotionModalVisibility = (paramRow: any) => {
    setSelectedSkuCode(paramRow?.batchCode);
    dispatch(setDiscountModalState(true));
  };

  const handleSearchValueChange = (newValue: string) => {
    setSearchedValue(newValue);
  };

  const setDataRowAndFooter = async (
    data: any,
    tableRows: viewManageOrderRowsData[] = [],
    tableHeaders?: Record<string, string>
  ) => {
    try {
      let stocksData: any = {};

      const dbResult = await getDataFromLocalDb("Product");
      const products: any = dbResult?.data?.[0]?.data ?? {};

      // special case when we need to populate the rows with updated data
      if (tableRows?.length) {
        const updatedRows = tableRows?.map((row: viewManageOrderRowsData) => {
          const skuStock = stocksData?.[row?.batchCode];
          const {
            availableCaseQty,
            availablePieceQty,
            availableOtherQty,
            committedCaseQty,
            committedPieceQty,
            committedOtherQty,
          } = skuStock || {};
          const availableStock = {
            cs: availableCaseQty || 0,
            pc: availablePieceQty || 0,
            other: availableOtherQty || 0,
            csComitted: committedCaseQty || 0,
            pcComitted: committedPieceQty || 0,
            otherComitted: committedOtherQty || 0,
          };
          return { ...row, availableStock };
        });
        setRows(updatedRows || []);
        return;
      }

      const totalData = getOrderTotalRowData(data, tableHeaders ?? TableHeaders, ConfigDictionary);
      setTotalFooterValue(totalData);

      let dataArr: viewManageOrderRowsData[] = [];
      let taxAmount: number = 0;

      const orderUomCheckConfig = await getConfigData("catalogue_configuration", "orderUomCheck");
      const orderUomCheck = orderUomCheckConfig[0]?.configValue ?? "";

      data?.orderDetails?.forEach((item: any, index: any) => {
        const {
          batchCode,
          price,
          casePrice,
          otherUnitPrice,
          pieceQuantity,
          caseQuantity,
          otherUnitQuantity,
          productInfo,
          creationTime,
          netAmount,
          initialAmount,
          extendedAttributes,
          type,
          discountValue,
          initialNormalizedQuantity,
          couponValue
        } = item;
        const discount = truncateToTwoDecimals((discountValue ?? 0) + (couponValue ?? 0));
        const finalAmount = netAmount ? truncateToTwoDecimals(netAmount) : "0";
        const actualAmount = initialAmount ? truncateToTwoDecimals(initialAmount) : "0";
        const skuDescription = productInfo?.skuDescription ?? "-";
        const formattedPrice = truncateToTwoDecimals(price ?? 0);
        const formattedCasePrice = truncateToTwoDecimals(casePrice ?? 0);
        const formattedOtherPrice = truncateToTwoDecimals(otherUnitPrice ?? 0);
        const id = `row-${index + 1}`;

        const freeItem: boolean = type === "freeItem" || (!insideManageInvoice && item?.initialNormalizedQuantity === 0)

        const taxInfo = extendedAttributes?.taxInfo;
        if(!freeItem) {
          taxInfo?.forEach((taxType: any) => (taxAmount += taxType?.taxAmount || 0));
        }

        const skuDiscountInfo = [
          { discountType: "Coupon", discountAmount: couponValue ?? 0 },
         { discountType: "Scheme", discountAmount: discountValue ?? 0 },
        ]
        
        // setting available stock of the product
        const skuStock = stocksData?.[batchCode];

        const {
          availableCaseQty,
          availablePieceQty,
          availableOtherQty,
          committedCaseQty,
          committedPieceQty,
          committedOtherQty,
        } = skuStock || {};
        const availableStock = {
          cs: availableCaseQty || 0,
          pc: availablePieceQty || 0,
          other: availableOtherQty || 0,
          csComitted: committedCaseQty || 0,
          pcComitted: committedPieceQty || 0,
          otherComitted: committedOtherQty || 0,
        };

        const status = data?.status?.toLocaleUpperCase();

        dataArr.push({
          id,
          batchCode,
          skuDescription,
          caseQuantity,
          pieceQuantity,
          otherUnitQuantity,
          casePrice: formattedCasePrice,
          price: formattedPrice,
          otherUnitPrice: formattedOtherPrice,
          actualAmount,
          discount,
          finalAmount,
          creationTime,
          availableStock,
          taxInfo,
          status,
          uom: orderUomCheck === "true" ? (products[batchCode]?.uom ?? "") : "all",
          initialCaseQuantity: caseQuantity,
          initialOtherUnitQuantity: otherUnitQuantity,
          initialPieceQuantity: pieceQuantity,
          freeItem,
          caseToPieceQty: products[batchCode]?.caseToPieceQuantity ?? extendedAttributes?.["caseToPiece"] ?? 99999,
          otherToPieceQty: products[batchCode]?.otherUnitToPieceQuantity ?? 99999,
          initialNormalizedQuantity,
          skuDiscountInfo,
          actualCaseQuantity: caseQuantity,
          actualPieceQuantity: pieceQuantity,
          actualOtherUnitQuantity: otherUnitQuantity
        });
      });

      const cancelledInvoice: boolean =
        data?.status?.toLowerCase() === "rejected" && data?.invoiceNumber ? true : false;
      const eInvoiced: boolean =
        data?.status?.toLowerCase() === "invoiced" &&
        (data?.eInvoice === "true" || data?.extendedAttributes?.IRNDtls);

      let eWayBilled: boolean = false;
      setOrderData({ ...data, taxAmount, cancelledInvoice, eInvoiced, eWayBilled});
      setRows(dataArr);
    } catch (e) {
      console.error(e);
      setGenericModalProps(
        getGenericModalProps("error", "Error while fetching available stock data")
      );
    }
  };

  const getOrderDetails = async (orderId: string, TableHeaders?: Record<string, string>) => {
    try {
      let res, data;

      if (insideManageInvoice) {
        try {
          res = await getSalesData(orderId);
          if (res?.data?.features?.length == 0) throw new Error();
          data = {
            ...res?.data?.features?.[0],
            orderDetails: res?.data?.features?.[0]?.salesDetails,
          };

          data?.orderDetails?.map((item: any) => {
            const { initialCaseQuantity, initialPieceQuantity, initialOtherUnitQuantity } =
              item || {};
            item.caseQuantity = initialCaseQuantity;
            item.pieceQuantity = initialPieceQuantity;
            item.otherUnitQuantity = initialOtherUnitQuantity;
          });
          const updatedOrderDetails = data?.orderDetails
            ?.filter((item: any) => {
              const { caseQuantity, pieceQuantity, otherUnitQuantity } = item || {};

              if (!(caseQuantity == 0 && pieceQuantity == 0 && otherUnitQuantity == 0)) return item;
            })
            ?.filter((item: any) => Boolean(item));

          data.orderDetails = updatedOrderDetails;
          setCanPushToEInvoice(
            data?.hasGstin &&
              data?.eInvoice != "true" &&
              !Boolean(data?.extendedAttributes?.IRNDtls)
          );
          setInvoiceExpired(checkIfNHoursPassed(data?.creationTime, ConfigDictionary?.invoiceExpiryCheckValue ?? 72) && data?.status?.toLowerCase() === "invoiced" && Boolean(ConfigDictionary?.invoiceExpiryCheck))
        } catch (e) {
          console.error(e);
          throw new Error();
        }
      } else {
        try {
          res = await getSingleOrder(orderId);
          data = res?.data?.features?.[0];
        } catch (e) {
          console.error(e);
          throw new Error();
        }
      }

      await setDataRowAndFooter(data ?? {}, [], TableHeaders);
    } catch (err) {
      console.error(err);
      setGenericModalProps(
        getGenericModalProps(
          "error",
          `${insideManageInvoice ? `Invoice` : `Order`} with order-number : ${orderId} not found`
        )
      );
    } finally {
      setLoader(false);
    }
  };

  const fetchRequiredConfigs = async () => {
    try {
      const statusConfig = insideManageInvoice
        ? await getConfigData("dms_configuration", "invoiceStages")
        : await getConfigData("order_configuration", "orderTrackingStages");
      const rejectionReasonsConfig = await getConfigData(
        "dms_configuration",
        "orderCancellationReasons"
      );

      const res = await getConfigData("dms_configuration", "hideAddMoreInEditOrder");
      const res2 = await getConfigData("dms_configuration", "disableEditInvoiceFlow");
      const res3 = await getConfigData("dms_configuration", "disableStockCheck");
      const res4 = await getConfigData("dms_configuration", "hideItemLevelTaxInfo");
      const res5 = await getConfigData("dms_configuration", "hideOrderProgressCard");

      const invoiceReportConfig = await getConfigData("dms_configuration", "invoiceReportId")
      const invoiceReportName = invoiceReportConfig[0]?.configValue[0]?.reportName ?? ""
      const invoiceTaskName = invoiceReportConfig[0]?.configValue[0]?.taskName ?? ""
      setInvoiceReportName(invoiceReportName)
      setInvoiceTaskName(invoiceTaskName)
      const res6 = await getConfigData("order_configuration", "goToInvoiceRedirectionButton");
  
      hideAddMoreInEditOrder.current = res[0]?.configValue ?? false;
      disableEditInvoiceFlow.current = res2[0]?.configValue ?? false;
      disableStockCheck.current = res3[0]?.configValue ?? false;
      hideItemLevelTaxInfo.current = res4[0]?.configValue ?? false;
      hideOrderProgressCard.current = res5[0]?.configValue ?? false;
      showGoToInvoiceRedirectionButton.current = res6[0]?.configValue ?? false;

      setRejectionReasons(rejectionReasonsConfig?.[0]?.configValue ?? []);
      setOrderTrackingConfig(statusConfig[0]?.configValue ?? []);

    } catch (e) {
      console.error("Error while fetching configs", e);
    }
  };

  useEffect(() => {
    const tableData = setAndGetViewOrderEditTableHeader(ConfigDictionary);
    SetViewOrderEditTableHeader(tableData);
  
    if (orderId) {
      setLoader(true);
  
      // Chain the promises to ensure fetchRequiredConfigs runs first
      fetchRequiredConfigs()
        .then(() => getOrderDetails(orderId, tableData))
        .finally(() => {
          setLoader(false);
        });
    } else {
      navigate("/dashboard/sale/manageOrders", { replace: true });
      return;
    }
  }, [orderId, insideManageInvoice]);

  const showStockExceedWarning = () => {
    const orderStatus = orderData?.status?.toUpperCase();

    return (
      (!checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current) &&
      (ordersWithStockExceedingWarning?.includes(orderStatus) || insideManageInvoice)) && !disableStockCheck.current
    );
  };
  const viewOrderConfig = getViewOrderConfig(
        handlePromotionModalVisibility,
        insideManageInvoice,
        TableHeaders,
        disableStockCheck.current,
        hideItemLevelTaxInfo.current
      );

  const columns: any[] = viewOrderConfig?.columns;

  const filteredRows: viewManageOrderRowsData[] = rows.filter(row => {
    if (isEditing && row?.freeItem) return false;
  
    if (!searchedValue) return true;
  
    const search = searchedValue.toLowerCase().replace(/[\s-_]/g, '');
    const batch = row.batchCode?.toLowerCase() || '';
    const sku = row.skuDescription?.toLowerCase() || '';
  
    return (
      batch.includes(searchedValue.toLowerCase()) ||
      batch.replace(/[\s-_]/g, '').includes(search) ||
      sku.includes(searchedValue.toLowerCase()) ||
      sku.replace(/[\s-_]/g, '').includes(search)
    );
  });  

  if (loader) {
    return <Loader />;
  }

  return (<>
    <div className="view_order_parent_vo" onWheel={(e) => handleScrollCustomDataGrid(e, setIsScrolling)}>
      <div className="top-heading-tov">
        <div className="claim-summary-heading" style={{ alignItems: "center" }}>
          <p
            className="heading margin0"
            style={{ color: "#909090", cursor: "pointer" }}
            onClick={() => navigate(-1)}
          >
            Create New Claim &gt;
          </p>
          &nbsp;&nbsp;
          <p className="heading margin0">Invoice Details</p>
        </div>
        <div style={{ width: "280px" }}>
        <Search searchFunction={handleSearchValueChange}/>
        </div>
    </div>
              <CustomAccordian
          expanded={!isScrolling}
          onCustomAccordionToggle={onCustomAccordionToggle}
          isSecondHalf={true}
          metaData1={getMetaData1()}
          data1={orderData}
          metaData2={metaData2}
          data2={orderData}
          header={
            insideManageInvoice
              ? `Invoice No. ${orderData?.invoiceNumber}`
              : `Order No. ${orderData?.orderNumber}`
          }
          redirectionUrl={
            !insideManageInvoice && !disableEditInvoiceFlow.current
              ? `/dashboard/sale/manageInvoices/viewInvoice/${orderData?.orderNumber ?? ""}`
              : ``
          }
          label1={insideManageInvoice ? "Invoice Summary" : "Order Summary"}
          label2="Outlet Info"
          dateAndTimeLabel={`${insideManageInvoice ? `Invoice` : `Order`} date & time`}
          dateAndTimeValue={orderData?.creationTime}
          statusConfig={orderTrackingConfig}
          status={orderData?.status}
          showOrderSource={true}
          metaData1ChunkSize={4}
        />
         <div>
          <div className="view_order_button_container">
            <BorderHeading>
              {insideManageInvoice ? "Invoice Details" : "Order Details"}
            </BorderHeading>
            {showStockExceedWarning() && (
              <p className="invalid_qty_text">
                <DisclaimerIcon />
                Ordered quantity exceeds the stock availability
              </p>
            )}
            {orderData?.status?.toUpperCase() === "REJECTED" ||
            orderData?.status?.toUpperCase() === "CANCELLED" ||
            (orderData?.status?.toUpperCase() === "INVOICED" && !insideManageInvoice) ? (
              <></>
            ) : (
              <></>
            )}
          </div>
        </div>
        {loader || editLoading ? (
          <Loader />
        ) : (
          <CustomTablewithTotalInfo
            data={filteredRows}
            columns={columns}
            totals={totalFooterValue}
            headerBackgroundColor="#F0FBFF"          />
        )}
      </div>
      <NewDiscountModal skuData={orderData} selectedSkuCode={selectedSkuCode} />
</>
  );
};

export default InvoiceDetailsTov;